// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { userListUsersTableStyles } from "@insite/content-library/Widgets/UserList/UserListUsersTable";
import { getNotifyStyle } from "@keller/App/Components/Notify";
import { xScreen } from "@keller/XDL/Utilities";
import { css } from "styled-components";

userListUsersTableStyles.noResultsText = {
    ...getNotifyStyle("info"),
};

// Remove default style
userListUsersTableStyles.noResultsContainer = {
    css: css``,
};

userListUsersTableStyles.dataTableBody = {  
    css: css`
        ${xScreen("lte", "sm")} {
            th:first-child {
                position: relative;
                left: 0;
            }
        }
    `,
};
userListUsersTableStyles.dataTableHead = {  
    css: css`
        ${xScreen("lte", "sm")} {
            th:first-child {
                position: relative;
                left: 0;
            }
        }
    `,
};
userListUsersTableStyles.container={
    css: css`
    margin-bottom: 24px;
`,
}
